import React, { Children, type ReactNode } from 'react'
import { css } from '@emotion/core'
import { ResponsiveProvider } from '@fs/zion-ui/quarks-authorized-use-only'
import { minWidthCss } from './common'
import { hasValidChildren } from '../hasValidChildren'

type Props = {
  children: ReactNode
  columnCount?: number
}

const separatorCss = css`
  display: grid;
  gap: 1px;
`

export default function InBetweenSeparatorGrid({ children, columnCount = 1 }: Props): JSX.Element {
  return (
    <div
      css={separatorCss}
      style={{
        gridTemplateColumns: `repeat(${columnCount}, 1fr)`,
      }}
    >
      {Children.map(children, (child) => {
        if (hasValidChildren(child)) {
          return (
            <div css={minWidthCss}>
              <ResponsiveProvider>{child}</ResponsiveProvider>
            </div>
          )
        }
        return null
      })}
    </div>
  )
}
